import { chatCompletions, getChatHistoryListApi } from '../api';

// 拉取历史记录并转换为组件可用的 message 结构（未做 Markdown 渲染）
export const fetchChatHistory = async (apiPath = '') => {
    const res = await getChatHistoryListApi(apiPath);
    const response = res?.data || res;
    const history = response?.history;

    if (!Array.isArray(history) || history.length === 0) {
        return [];
    }

    const reversed = [...history].reverse(); // 旧数据在前时反转，让旧消息先渲染

    return reversed.reduce((list, item) => {
        if (!item) return list;
        const id = item.message_id || `${item.timestamp || ''}-${list.length}`;
        list.push({
            id,
            type: 'user',
            content: item.user_content
        });
        list.push({
            id,
            type: 'agent',
            content: item.model_output,
            isStreaming: true
        });
        return list;
    }, []);
};

// 发起聊天流请求，保持与原 chatCompletions 相同的签名
export const startChatCompletion = async (payload, onMessage, onError, onComplete) => {
    return chatCompletions(payload, onMessage, onError, onComplete);
};

